import React, { useState } from "react";
import "../static/css/Career.css";

function Career() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobileNo: "",
    gender: "",
    position: "",
    dob: "",
    qualification: "",
    portfolio: "",
    resume: null,
    lastCompany: "",
    experienceYear: "",
    experienceMonth: "",
    comments: ""
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({
      ...prev,
      resume: e.target.files[0]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ type: "", text: "" });

    // Validation
    if (!formData.firstName.trim() || !formData.lastName.trim() || !formData.email.trim() || !formData.mobileNo.trim()) {
      setMessage({ type: "error", text: "Please fill all required fields" });
      return;
    }

    setLoading(true);

    try {
      const formDataToSend = new FormData();
      Object.keys(formData).forEach(key => {
        if (formData[key]) {
          formDataToSend.append(key, formData[key]);
        }
      });

      const response = await fetch("https://backend.skpandco.in/career", {
        method: "POST",
        body: formDataToSend,
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setMessage({ type: "success", text: data.message || "Application submitted successfully!" });
        // Clear form
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          mobileNo: "",
          gender: "",
          position: "",
          dob: "",
          qualification: "",
          portfolio: "",
          resume: null,
          lastCompany: "",
          experienceYear: "",
          experienceMonth: "",
          comments: ""
        });
      } else {
        setMessage({ type: "error", text: data.message || "Failed to submit application" });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setMessage({ 
        type: "error", 
        text: "Unable to connect to server. Please try again later." 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="career-container">
      <div className="career-box">
        <h2>-Apply Here-</h2>
        <p className="career-description">
          We nurture and cultivate a sense pride in the work and create team leaders. 
          Your growth chart will be governed by well-defined transparent policies of the firm. 
          Apply via the form given below and meet us or face to face interview.
        </p>
        
        <form onSubmit={handleSubmit} className="career-form">
          <div className="form-row">
            <div className="form-group">
              <label>First name <span className="required">*</span></label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                disabled={loading}
                required
              />
            </div>
            <div className="form-group">
              <label>Last name <span className="required">*</span></label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                disabled={loading}
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Email <span className="required">*</span></label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                disabled={loading}
                required
              />
            </div>
            <div className="form-group">
              <label>Mobile No <span className="required">*</span></label>
              <input
                type="tel"
                name="mobileNo"
                value={formData.mobileNo}
                onChange={handleChange}
                disabled={loading}
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Gender <span className="required">*</span></label>
              <select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                disabled={loading}
                required
              >
                <option value="">Select..</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div className="form-group">
              <label>Position you are applying for</label>
              <input
                type="text"
                name="position"
                value={formData.position}
                onChange={handleChange}
                disabled={loading}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Date Of Birth (DD/MM/YYYY)<span className="required">*</span></label>
              <input
                type="text"
                name="dob"
                placeholder="DD/MM/YYYY"
                value={formData.dob}
                onChange={handleChange}
                disabled={loading}
                required
              />
            </div>
            <div className="form-group">
              <label>Highest Qualification</label>
              <input
                type="text"
                name="qualification"
                value={formData.qualification}
                onChange={handleChange}
                disabled={loading}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Portfolio website</label>
              <input
                type="url"
                name="portfolio"
                placeholder="http://"
                value={formData.portfolio}
                onChange={handleChange}
                disabled={loading}
              />
            </div>
            <div className="form-group">
              <label>Upload Resume <span className="required">*</span>(Max size 1 mb )</label>
              <input
                type="file"
                name="resume"
                accept=".pdf,.doc,.docx"
                onChange={handleFileChange}
                disabled={loading}
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group full-width">
              <label>Last company you worked for</label>
              <input
                type="text"
                name="lastCompany"
                value={formData.lastCompany}
                onChange={handleChange}
                disabled={loading}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Years Of Experience</label>
              <div className="experience-row">
                <div className="experience-field">
                  <label className="sub-label">Year</label>
                  <select
                    name="experienceYear"
                    value={formData.experienceYear}
                    onChange={handleChange}
                    disabled={loading}
                  >
                    <option value="">Select Year</option>
                    {[...Array(50)].map((_, i) => (
                      <option key={i} value={i}>{i}</option>
                    ))}
                  </select>
                </div>
                <div className="experience-field">
                  <label className="sub-label">Month</label>
                  <select
                    name="experienceMonth"
                    value={formData.experienceMonth}
                    onChange={handleChange}
                    disabled={loading}
                  >
                    <option value="">Select Month</option>
                    {[...Array(12)].map((_, i) => (
                      <option key={i} value={i}>{i}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group full-width">
              <label>Reference / Comments / Questions</label>
              <textarea
                name="comments"
                rows="5"
                value={formData.comments}
                onChange={handleChange}
                disabled={loading}
              ></textarea>
            </div>
          </div>

          {message.text && (
            <div className={`message ${message.type}`}>
              {message.text}
            </div>
          )}

          <div className="form-submit">
            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Send Application"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Career;
